import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';

import AssignMemberToOrderStage from '@components/assign-team-member/AssignMemberToOrderStage';
import DateRangeComponent from '@components/DateRangeComponent';
import { toastError, toastSuccess } from '@components/Toast';

import useFetch from '@hooks/useFetch';

import OrderDashboard from '@features/order-dashboard/OrderDashboard';
import AddReview from '@features/supplier/component/AddReview';
import StyleCard from '@features/order/components/StyleCard';
import CreateTna from '@features/order/components/TNA/create-tna';
import EtdDetails from '@features/order/components/TNA/EtdDetails';
import SearchTnaProduct from '@features/order/components/TNA/SearchTnaProduct';
import { PLANNING_STATUS } from '@features/order/utils/projectUtil';
import OrderTask from '@features/task/components/OrderTask';
import EtdDateFilter from '@features/order-dashboard/component/EtdDateFilter';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchOrderDashboardHeadings } from '@store/actions/OrderDashboardAction';

import { getOrderByOrderDashboardId } from '@services/orderDashboard';
import tnaService from '@services/tna-service';

import ApiClient from '@lib/apiClient';

import { printApiError, replaceUnderLine, STATIC_SET_CONSTANTS } from '@utils/Util';

import { OrderContext } from '@context/OrderContext';

const TnaRunning = ({ orderId, brandName }) => {
	const [productList, setProductList] = useState([]);
	const [isAllSelected, setisAllSelected] = useState(true);
	const [selectedStyleRfqId, setSelectedStyleRfqId] = useState(null);
	const [selecteStylePlanningDetail, setSelecteStylePlanningDetail] = useState([]);
	const [, setPlanningStatus] = useState(null);
	const [projectList, setProjectList] = useState([]);
	const [showTaskDetailsModal, setShowTaskDetailsModal] = useState(false);
	const [reviseInfo, setReviseInfo] = useState(null);
	const [selectedTaskId, setSelectedTaskId] = useState(null);
	const [isReview, setIsReview] = useState(null);
	const [productsOfSet, setProductsOfSet] = useState([]);
	const [isTnaHasSetProduct, setIsTnaHasSetProduct] = useState(false);
	const [activeSetMemberId, setActiveSetMemberId] = useState(null);
	const { responseData: memberData } = useFetch('getProjectMembers', orderId);
	const [isFinishTabVisible, setIsFinishTabVisible] = useState(false);
	const [urlRfqId, setUrlRfqId] = useState(null);
	const dispatch = useDispatch();
	const location = useLocation();
	const { id } = useParams();
	const [searchKey, setSearchKey] = useState('');
	const [listOfAllProduct, setListOfAllProduct] = useState([]);
	const [selectedStyle, setSelectedStyle] = useState(null);
	const [rfqStatusInfoList, setRfqStatusInfoList] = useState([]);
	const [selectedETD, setSelectedETD] = useState(0);
	const [selectedIndex] = useState(0);
	const [selectedDate, setSelectedDate] = useState('All');

	const getUniqueFactoryDeliveryDates = (items) => {
		const factoryDeliveryDates = items.map((item) => item.factoryDeliveryDate);
		return [...new Set(factoryDeliveryDates)];
	};

	const uniqueFactoryDeliveryDates = getUniqueFactoryDeliveryDates(productList);

	const handleDateSelection = (date) => {
		let filteredProduct = productList;
		if (date !== 'All') {
			filteredProduct = productList.filter((item) => item.factoryDeliveryDate === date);
		}
		setListOfAllProduct(filteredProduct);
		setSelectedDate(date);
	};

	useEffect(() => {
		if (listOfAllProduct.length > 0) {
			setRfqStatusInfoList(listOfAllProduct[0].rfqStatusInfoList);
		}
	}, [listOfAllProduct]);

	useEffect(() => {
		if (rfqStatusInfoList?.length > 0) {
			const baseRfq = rfqStatusInfoList?.find((rfq) => rfq.isBaseRfq);
			if (baseRfq) {
				setSelectedETD(baseRfq.rfqId);
			}
		}
	}, [rfqStatusInfoList]);

	useEffect(() => {
		setListOfAllProduct(productList);
	}, [JSON.stringify(productList)]);

	const handleSearch = (key) => {
		if (key === '') {
			setListOfAllProduct(productList);
		} else {
			const result = productList.filter((item) =>
				item?.referenceNumber.toLowerCase().includes(key.toLowerCase())
			);
			setListOfAllProduct(result);
		}
		setSearchKey(key);
	};

	useEffect(() => {
		const rfqIdParam = new URLSearchParams(location.search).get('rfqId');
		const rfqId = rfqIdParam && rfqIdParam.includes('?') ? rfqIdParam.split('?')[0] : rfqIdParam;
		let isId = new URLSearchParams(location.search).get('deliverableId') || null;
		let hideSideBar = new URLSearchParams(location.search).get('hideSideBar') || false;
		if (isId) {
			setSelectedTaskId(isId);
			if (!hideSideBar) setShowTaskDetailsModal(true);
		}
		setUrlRfqId(rfqId);
	}, [location.search]);

	useEffect(() => {
		if (urlRfqId && productList.length > 0) {
			const style = productList.find((item) => item.rfqId === parseInt(urlRfqId));
			onSelectStyle(urlRfqId);
			setSelectedStyle(style);
			style?.planningStatus === PLANNING_STATUS.PENDING ||
			style?.planningStatus === PLANNING_STATUS.SUBMITTED
				? onSelectStyleForPending(style?.rfqId)
				: onSelectStyle(style?.rfqId);
		}
	}, [urlRfqId, productList.length]);

	const onSetNewItems = () => {
		getStyleDetails(selectedStyleRfqId);
	};

	const onChangeDateRange = async (value1, _value2, id) => {
		const body = {
			endDate: value1
		};
		const endDateUpdateResponse = await tnaService.taskEndDateUpdate(body, id);
		if (endDateUpdateResponse?.success) {
			if (activeSetMemberId && !isFinishTabVisible) {
				getStyleDetails(selectedStyleRfqId, true, activeSetMemberId);
			} else {
				getStyleDetails(selectedStyleRfqId);
			}
			toastSuccess(endDateUpdateResponse?.message);
		}
	};

	const fetchDashboardInfo = async () => {
		const data = await tnaService.getOrderDashboardInfoByOrderId(id);
		await getProductList();
		setProjectList(data?.data || []);
	};

	const getAllStylePlanning = async () => {
		dispatch(openLoader());
		await fetchDashboardInfo();
		dispatch(closeLoader());
	};

	const getStyleDetails = async (rfqId, isLoading = true, idOfSetMember) => {
		if (isLoading) {
			dispatch(openLoader());
		}
		let stylePlanningDetailResponse;

		if (idOfSetMember) {
			stylePlanningDetailResponse = await tnaService.getRunningTnaStyleDetails(
				orderId,
				rfqId,
				idOfSetMember
			);
		} else {
			stylePlanningDetailResponse = await tnaService.getRunningTnaStyleDetails(orderId, rfqId);
		}
		setSelecteStylePlanningDetail(stylePlanningDetailResponse);
		if (isLoading) {
			dispatch(closeLoader());
		}
	};

	const getProductList = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.GET('getProjectProducts', orderId);
			setProductList(data);
			const updateSelectedStyle = data.find((item) => item?.id === selectedStyle?.id);
			if (updateSelectedStyle) {
				setSelectedStyle(updateSelectedStyle);
			}
		} catch (error) {
			toastError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const handleIndividualTna = (rfqId) => {
		getProductList();
		onSelectStyle(rfqId);
	};

	useEffect(() => {
		dispatch(fetchOrderDashboardHeadings());
		getAllStylePlanning(orderId);
	}, [orderId]);

	const onSelectStyle = (rfqId) => {
		setisAllSelected(false);
		setPlanningStatus('');
		setSelectedStyleRfqId(rfqId);
		const getSelectedStyle = productList.find(
			(product) =>
				parseInt(product.rfqId) === parseInt(rfqId) &&
				product?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT
		);
		if (getSelectedStyle && getSelectedStyle.setMemberList) {
			extractAndOrganizeSetMembers([getSelectedStyle]);
			setActiveSetMemberId(getSelectedStyle?.setMemberList[0]?.id);
			setIsTnaHasSetProduct(true);
			getStyleDetails(rfqId, '', getSelectedStyle?.setMemberList[0]?.id);
		} else {
			setActiveSetMemberId(null);
			setIsTnaHasSetProduct(false);
			getStyleDetails(rfqId);
		}
	};

	const onChangeTabOfSetMember = (member, index) => {
		if (activeSetMemberId !== member.id) {
			if (productsOfSet.length - 1 === index) {
				getStyleDetails(member?.rfqId, true);
			} else {
				getStyleDetails(member?.rfqId, true, member?.id);
			}
			setActiveSetMemberId(member?.id);
		}
	};

	const extractAndOrganizeSetMembers = (designsList = []) => {
		const membersOfSet = [];
		designsList.forEach((design) => {
			if (design.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT && design.setMemberList) {
				design.setMemberList.forEach((member) => {
					membersOfSet.push({
						...member
					});
				});
				membersOfSet.push({
					name: 'Finish',
					id: design?.id,
					rfqId: design?.rfqId
				});
			}
		});
		setProductsOfSet(membersOfSet);
	};

	const onSelectStyleForPending = (rfqId) => {
		setisAllSelected(false);
		setSelectedStyleRfqId(rfqId);
		setPlanningStatus('PENDING');
	};

	const onClickModalShow = (deliverableId) => {
		setSelectedTaskId(deliverableId);
		setShowTaskDetailsModal(true);
	};
	const resetRevisionInfo = () => setReviseInfo(null);

	const onApproveTask = async (taskId) => {
		dispatch(openLoader());
		const response = await tnaService.onApproveTask(taskId);
		if (response?.success) {
			if (activeSetMemberId && !isFinishTabVisible) {
				getStyleDetails(selectedStyleRfqId, true, activeSetMemberId);
			} else {
				getStyleDetails(selectedStyleRfqId);
			}
		}
		dispatch(closeLoader());
	};

	const materialType = (name) => {
		if (name === 'Branding') return 'Accessories';
		return name;
	};

	const onSelectFinishTab = () => {
		if (productsOfSet.length > 0) {
			const getFinshTab = productsOfSet.find((item) => item.id === activeSetMemberId);
			if (getFinshTab && getFinshTab.name === 'Finish') {
				setIsFinishTabVisible(true);
			} else {
				setIsFinishTabVisible(false);
			}
		}
	};

	const updateOrderStepByOrders = (orders) => {
		let modifiedProjectList = projectList?.map((item) => {
			let selectedOrder = orders.find((order) => order.id === item.id);
			if (selectedOrder) {
				item = selectedOrder;
			}
			return item;
		});
		setProjectList(modifiedProjectList);
	};

	useEffect(() => {
		onSelectFinishTab();
	}, [activeSetMemberId]);

	const renderSetMembersTab = () => {
		return (
			<div className="inner-tabs mt-3 mb-2">
				{isTnaHasSetProduct && (
					<ul>
						{productsOfSet.map((member, index) => (
							<li
								key={member?.id}
								className={`${activeSetMemberId === member.id ? 'active' : ''}`}
								onClick={() => onChangeTabOfSetMember(member, index)}
							>
								{index !== productsOfSet.length - 1 && 'TNA for'} {member?.name}
							</li>
						))}
					</ul>
				)}
			</div>
		);
	};

	const returnStatusIcon = (task, deliverableId, style) => {
		if (
			task?.formattedTaskStatus === 'EXPIRED' ||
			task?.formattedTaskStatus === 'PENDING' ||
			task?.formattedTaskStatus === 'RUNNING'
		)
			return (
				<>
					<Tooltip title="Complete" placement="top-start" arrow>
						<img
							src={`${process.env.PUBLIC_URL}/icons/due-green.svg`}
							alt="due"
							className="state"
							onClick={() => {
								if (task?.stepName === 'Handover to forwarder') {
									setIsReview(task.id);
								} else onApproveTask(task.id);
							}}
						/>
					</Tooltip>
					{task?.stepType === 'REVIEW' ? (
						<Tooltip title="Revise" placement="top-start" arrow>
							<img
								className="state"
								src={`${process.env.PUBLIC_URL}/icons/Update-red.svg`}
								alt="update"
								onClick={() => {
									setReviseInfo({
										id: task.id,
										stepName: task.stepName
									});
									onClickModalShow(deliverableId);
								}}
							/>
						</Tooltip>
					) : null}
					{isReview === task.id && (
						<AddReview
							onSuccess={() => {
								onApproveTask(task.id);
								setIsReview(null);
							}}
							onCloseReview={() => setIsReview(null)}
							supplierDetails={{
								supplierName: style?.deliverableResponse?.supplierName,
								supplierId: style?.deliverableResponse?.supplierId
							}}
						/>
					)}
				</>
			);
		else
			return (
				<Tooltip title="Completed" placement="top-start" arrow>
					<img src={`${process.env.PUBLIC_URL}/icons/Success.svg`} alt="" className="state" />
				</Tooltip>
			);
	};

	const renderInputTargetItem = (task) => {
		let title = Math.sign(task?.extraProductionTargetPercentage) === -1 ? 'PO' : 'PO+';
		if (task?.productionTarget) {
			return (
				<div className="production-details">
					<div className="production-details-btn">
						<span className="blue_dark_01">{task?.actualProductionQuantity || 0}</span>/
						{task?.productionTarget}
						<span className="percentage pl-1">
							({title}
							{parseFloat(task.extraProductionTargetPercentage).toFixed(2)}%)
						</span>
						<span className="devider">|</span> Bal:
						<span className="gray_dark_01">
							{parseInt(task?.productionTarget) - parseInt(task?.actualProductionQuantity || 0)}
						</span>
					</div>
				</div>
			);
		}
	};

	const returnTaskRow = (task, length, deliverableId, style, isMaterialTask = false) => {
		return (
			<div key={task?.id} className="single-task">
				<div className="d-flex justify-content-between align-items-center">
					<div className="w-100 d-flex align-items-center pl-4">
						{returnStatusIcon(task, deliverableId, style)}
						<div
							className="cursor-pointer regular-12 w-100"
							onClick={() => onClickModalShow(deliverableId)}
						>
							{isMaterialTask ? <span></span> : null}
							{length === 1 ? task?.stepDescription : task?.stepName}
							{renderInputTargetItem(task)}
							{(task?.formattedTaskStatus === 'COMPLETED' ||
								task?.formattedTaskStatus === 'APPROVED' ||
								task?.formattedTaskStatus === 'LATE_APPROVED') && (
								<>
									<span className="green state ml-2 mr-1">
										<img
											src={`${process.env.PUBLIC_URL}/icons/tick-green.png`}
											className="mr-1"
										/>
										{task?.actualEndDate && moment(task?.actualEndDate).format('D MMM')}
									</span>
									{task?.dateOver > 0 ? (
										<span className="red date-count state mr-1">+{task?.dateOver}d</span>
									) : task?.dateOver < 0 ? (
										<span className="green date-count state mr-1">{task?.dateOver}d</span>
									) : null}
								</>
							)}

							{task?.formattedTaskStatus === 'EXPIRED' && (
								<>
									<span className="status unsafe state ml-2 mr-1">
										<img
											src={`${process.env.PUBLIC_URL}/icons/alert-octagon-white.svg`}
											alt="update"
										/>{' '}
										+{task?.dateOver}d
									</span>
								</>
							)}

							{task?.revisionCount && (
								<span className="status red-alert ml-1 mr-1">
									<img src={`${process.env.PUBLIC_URL}/icons/Update.svg`} alt="update" />
									{task?.revisionCount}
								</span>
							)}
						</div>
					</div>

					<AssignMemberToOrderStage
						memberList={memberData?.memberList}
						taskInfo={task}
						onAddOrDeleteSuccess={() => onSetNewItems()}
					/>
					<div className="date-details">
						<span className="regular-12 mr-2">
							{task?.formattedTaskStatus === 'PENDING' && task?.isAffected && (
								<img src={`${process.env.PUBLIC_URL}/icons/exclamation-circle.svg`} />
							)}
							{task?.previousEndDate && (
								<span className="tag mr-2">
									{moment(task?.previousEndDate).format('D MMM, YY')}
								</span>
							)}
						</span>
						<span>
							<DateRangeComponent
								item={{ value1: task?.startDate, value2: task?.endDate }}
								onChange={onChangeDateRange}
								itemId={task?.id}
								single
							/>
						</span>
					</div>
				</div>
			</div>
		);
	};

	const renderDeliveryDetails = () => {
		const selectedData = productList?.find(
			(item) => parseInt(item.rfqId) === parseInt(selectedStyleRfqId)
		);
		return (
			<div className="runnig-order-date-status p-3 bg-white mb-2 d-flex justify-content-between">
				<div className="d-flex align-items-center tna-title">
					<Link
						to={`/suppliers/view/${selectedData?.supplierId}`}
						target={'_blank'}
						className="semibold-16 gray_dark_01 ml-2"
					>
						{selectedData?.supplierName}
					</Link>
				</div>
				<EtdDetails selectedStyleDetails={selectedData} selectedStyle={selectedData} />
			</div>
		);
	};

	const closeModal = () => {
		setReviseInfo(null);
		setShowTaskDetailsModal(false);
	};

	const getOrderInfoByDashboardId = async (orderDashboardId) => {
		try {
			const { data } = await getOrderByOrderDashboardId(`?rfqIdList=${orderDashboardId}`);
			if (data?.[0]) {
				let modifiedProjectList = projectList?.map((item) => {
					if (item.id === orderDashboardId) {
						item = data[0];
					}
					return item;
				});
				setProjectList(modifiedProjectList);
			}
		} catch (error) {
			printApiError(error);
		}
	};

	return (
		<div className="tna-container production-tna-container bg-gray">
			<div className="tna-header d-flex align-items-center align-self-center justify-content-between pb-4">
				<div className="d-flex align-items-center align-self-center justify-content-between pb-4">
					<h3 className="regular-16 weight-600 gray_dark_01 m-0">All Styles</h3>
					<EtdDateFilter
						selectedDate={selectedDate}
						handleDateSelection={handleDateSelection}
						uniqueDeliveryDates={uniqueFactoryDeliveryDates}
					/>
				</div>
				<div className="tna-action d-flex">
					<SearchTnaProduct searchValue={searchKey} handleSearch={handleSearch} />
				</div>
			</div>
			<div className="tna-tab-container scroll-x-label p-0 mt-2">
				<div
					className={`${
						productList?.length <= 0
							? 'tna-all-item'
							: 'tna-all-item tna-production-all-item d-flex scroll-x-label'
					}`}
				>
					<div
						className={
							isAllSelected
								? ' all-style-tab d-flex align-items-center justify-content-center cursor-pointer active'
								: 'production-all-style d-flex align-items-center justify-content-center cursor-pointer'
						}
						onClick={() => {
							dispatch(fetchOrderDashboardHeadings());
							setisAllSelected(true);
							!isAllSelected && getAllStylePlanning(orderId);
							setSelectedStyleRfqId(null);
						}}
					>
						<div className="item-text">
							<p className="gray_dark_01 reguar-12">All Styles</p>
						</div>
					</div>
					{listOfAllProduct.map((style, index) => {
						return (
							<StyleCard
								key={`${style?.id}-${index}`}
								product={style}
								isSelected={parseInt(style?.rfqId) === parseInt(selectedStyleRfqId)}
								onSelectProduct={() => {
									setSelectedStyle(style);
									style?.planningStatus === PLANNING_STATUS.PENDING ||
									style?.planningStatus === PLANNING_STATUS.SUBMITTED
										? onSelectStyleForPending(style?.rfqId)
										: onSelectStyle(style?.rfqId);
								}}
								selectedETD={selectedETD}
								selectedIndex={selectedIndex}
							/>
						);
					})}
				</div>
			</div>

			{isAllSelected && (
				<>
					<div className="tna-list-view-container">
						<div className="tna-list-view-items order-dashboard-tna-view">
							<OrderDashboard
								requestFrom="ORDER_DETAILS"
								orderStore={projectList}
								callback={fetchDashboardInfo}
								showSummary={false}
								getOrderInfoByDashboardId={getOrderInfoByDashboardId}
								updateOrderStepByOrders={updateOrderStepByOrders}
							/>
						</div>
					</div>
				</>
			)}

			{!isAllSelected && selectedStyle?.planningStatus === PLANNING_STATUS.COMPLETED && (
				<div className="tna-accordion-container">
					{renderDeliveryDetails()}
					{renderSetMembersTab()}
					<div className="accordion mt-1" id="accordionTna">
						{selecteStylePlanningDetail?.map((style) => {
							return (
								<div key={style?.deliverableResponse.id} className="card">
									<div className="card-body">
										<div className="all-tna-tasks">
											{style?.stepResponseList && (
												<div className="materials-task-group">
													{style?.stepResponseList?.length > 1 && (
														<div
															key={style?.deliverableResponse.name}
															className="single-task "
														>
															<div className="d-flex justify-content-between align-items-center">
																<p className="done regular-14 gray_dark_01">
																	{style?.deliverableResponse.name}
																</p>
															</div>
														</div>
													)}
													{style?.stepResponseList &&
														style?.stepResponseList.map((task) =>
															returnTaskRow(
																task,
																style?.stepResponseList?.length,
																style?.deliverableResponse?.id,
																style,
																false
															)
														)}
												</div>
											)}
											{style?.materialWiseStepInfoList &&
												style?.materialWiseStepInfoList.map((material) => {
													return (
														<div
															className="materials-task-group"
															key={material?.stepMaterial.materialName}
														>
															<div className="single-task ">
																<div className="d-flex justify-content-between align-items-center">
																	<p className="done regular-14 gray_dark_01">
																		<span className="gray_dark_02 pr-2">
																			{materialType(
																				replaceUnderLine(
																					material?.stepMaterial
																						?.materialType
																				)
																			)}
																			:
																		</span>
																		{material?.stepMaterial.materialName}
																	</p>
																</div>
															</div>
															{material?.stepResponseList.map((task) => {
																return returnTaskRow(
																	task,
																	material?.stepResponseList?.length,
																	style?.deliverableResponse?.id,
																	style,
																	true
																);
															})}
														</div>
													);
												})}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			)}

			{((!isAllSelected && selectedStyle?.planningStatus === PLANNING_STATUS.PENDING) ||
				selectedStyle?.planningStatus === PLANNING_STATUS.SUBMITTED) && (
				<CreateTna
					orderId={orderId}
					isShowProducts={false}
					planningStatus={selectedStyle?.planningStatus}
					rfqId={selectedStyleRfqId}
					callback={handleIndividualTna}
					requestFrom="TNA_RUNNING"
					tnaRunningStyleStatus={selectedStyle?.planningStatus}
					getProductList={getProductList}
					selectedStyleDetailsFromRunning={selectedStyle}
					runningProductList={productList}
					setProductList={setProductList}
				/>
			)}

			<Modal
				show={showTaskDetailsModal}
				onHide={() => {
					setShowTaskDetailsModal(false);
					closeModal();
				}}
				className="modal-right task-conversation with-tag-person"
				aria-labelledby="example-custom-modal-styling-title"
			>
				<OrderContext.Provider
					value={{
						deliverableId: selectedTaskId,
						brandName,
						reviseInfo,
						orderId,
						closeModal,
						resetRevisionInfo
					}}
				>
					<OrderTask
						rfqId={selectedStyleRfqId}
						callback={() =>
							getStyleDetails(
								selectedStyleRfqId,
								false,
								activeSetMemberId && !isFinishTabVisible && activeSetMemberId
							)
						}
					/>
				</OrderContext.Provider>
			</Modal>
		</div>
	);
};

export default TnaRunning;
